var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "classification" }, [
    _vm._v(" 药品分类管理 "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }